import routes from "../routes/routes";

const { SETTINGS, BUSINESS_ACCOUNTS, APP_LIST } = routes;

export const navigation = [
    /*  {
        label: "Medias",
        slug: "medias",
        route: null,
        icon: "fas fa-image",
    }, */
    /*{
        label: NOTIFICATIONS.label,
        route: NOTIFICATIONS.route,
        icon: "notifications",
        color: "#2D3345",
    },*/
    {
        label: SETTINGS.label,
        route: SETTINGS.route,
        icon: "setting",
        color: "#2D3345",
    },
];

/** Header profile menu — keys match {@link Icon} in `src/base/components/Icon.jsx`. */
export const userMenu = [
    {
        label: BUSINESS_ACCOUNTS.label,
        route: BUSINESS_ACCOUNTS.route,
        icon: "accounts",
        permissions: BUSINESS_ACCOUNTS.permissions,
    },
    {
        label: APP_LIST.label,
        route: APP_LIST.route,
        icon: "apps-icon",
        permissions: APP_LIST.permissions,
    },
];
